import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { intraFreqX1HoChartConfig } from '../chartConfigs';

/**
 * Props for the IntraFreqX1HoEcharts component
 */
interface IntraFreqX1HoEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Intra-Frequency X2 Handover Success Rate Chart (LTE Site Level)
 * 
 * Displays intra-frequency handover metrics via X2 interface:
 * - Intra-Frequency X2 HO Success (count)
 * - Intra-Frequency X2 HO Attempt (count)
 * - Intra-Frequency X2 HO Success Rate (percentage)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (intraFreqX1HoChartConfig)
 * @see API: /api/lte/intra-freq-x2-ho?site_name={siteName}
 */

const IntraFreqX1HoEcharts: React.FC<IntraFreqX1HoEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={intraFreqX1HoChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default IntraFreqX1HoEcharts;
